import { ReportConfig ,ServiceQuickBiReportDataParams} from "@/component/common/report/report"
import { axiosHttp } from "@/utils/http"
import { convertSortParams,CountType  } from "../../share/params"
import { httpPc } from "@/utils/httpPc"
export interface QuickBiReportDataResponse {
  "hasNextPage": number // 0,
  "page": number // 1,
  "pageTotal": number // 0,
  "lastPageId": number // 0,
  "limit": number // 100,
  "count": number // 0,
  "countData": [],
  "listsDataSum": [],
  "listsData": Array<Record<string,string|number>>
}



/** @deprecated 用serviceQuickBiReportDataV2  */
export const serviceQuickBiReportData = (_params:ServiceQuickBiReportDataParams)=>{
  // let params = convertSortParams(_params)
  // let query = new URLSearchParams(Object.entries(params)).toString()
  // return axiosHttp.get<'',AxiosHttpPromise<QuickBiReportDataResponse>>(`/Manager/Report/quickBiReportData?${query}`)
  return serviceQuickBiReportDataV2(_params).then(res => res.data);
}
export const serviceQuickBiReportDataV2 = (_params:ServiceQuickBiReportDataParams)=>{
  let params = convertSortParams(_params)
  let query = new URLSearchParams(Object.entries(params)).toString()
  return httpPc.get<AxiosHttpPromise<QuickBiReportDataResponse>>(`/Manager/Report/quickBiReportData?${query}`)
}


// export enum CountType {
//   isRequestTable = 0,  //只有list数据
//   isRequestAll = 1,  /// list加count
//   isRequestCount = 2 // 只有count
// }


export const serviceQuickBiReportConfig = (params:{report:string})=>{
  let query = new URLSearchParams(Object.entries(params)).toString()
  return axiosHttp.get<'',AxiosHttpPromise<ReportConfig>>(`Manager/Report/quickBiReportConfig?${query}`)
}


